export const api = async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
        return response.text().then((text) => {
            throw Error(text);
        });
    }
    else {
        return response.json();
    }
};
//# sourceMappingURL=api.js.map